import { IVariadicFunction } from "@Components/shared/types";
import { useCallback, useEffect, useRef } from "react";

export function useDebounce(): [IVariadicFunction] {
    const timerRef = useRef(null);

    const handler = useCallback((callback: IVariadicFunction, delay: number) => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        timerRef.current = setTimeout(() => callback(), delay);
    }, []);

    useEffect(() => {
        // Clear the interval when the component unmounts
        return () => clearTimeout(timerRef.current);
    }, []);

    return [handler];
}
